export default __webpack_public_path__ + "static/media/icon_數據分析.57232123.svg";